import { render, staticRenderFns } from "./BackgroundCurve.vue?vue&type=template&id=31297b2e"
import script from "./BackgroundCurve.vue?vue&type=script&lang=js"
export * from "./BackgroundCurve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports